/**
 * poi对象的一些辅助接口
 */
const poiTypeMap = {
  A: 'attraction',
  C: 'city',
  H: 'hotel',
  P: 'store',
  D: 'store',
  V: 'poi_store',
  U: 'user',
  B: 'airport',
  S: 'shopping',
  F: 'food',
  G: 'fuel',
  E: 'entertainment',
  I: 'user_travel',
  J: 'user_hotel',
  'Z.O': 'custom_save',
  'Z.C': 'custom_save',
};

// poi类型
export function getType(poi) {
  if (typeof poi !== 'string') {
    poi = poi.poi_uid;
  }

  let end = poi.lastIndexOf('.');
  let prefix = poi.substring(0, end);

  return poiTypeMap[prefix];
}

export function isAttraction(poi) {
  return getType(poi) === 'attraction';
}

export function isHotel(poi) {
  let type = getType(poi);
  return type === 'hotel' || type === 'user_hotel';
}

export function isStore(poi) {
  return getType(poi) === 'store';
}

export function isCity(poi) {
  return getType(poi) === 'city';
}

// 取车门店
export function isPickup(poi) {
  if (typeof poi === 'string') {
    return poi.indexOf('P.') === 0;
  } else {
    return isStore(poi) && poi.poi_uid.indexOf('P.') === 0;
  }
}

// 还车门店
export function isDropoff(poi) {
  if (typeof poi === 'string') {
    return poi.indexOf('D.') === 0;
  } else {
    return isStore(poi) && poi.poi_uid.indexOf('D.') === 0;
  }
}


/**
 * 是否是自定义poi点
 * @param {*} poi 
 */
export function isUserTravel(poi) {  
  return getType(poi) === 'user_travel';
}

export function isUserHotel(poi) {  
  return getType(poi) === 'user_hotel';
}


/**
 * 获取poiUid或poi的flag
 */
const poiFlagMap = {
  A: 'poi',
  P: 'pickup',
  D: 'dropoff',
  H: 'hotel',
  J: 'hotel',
};
// 返回poi的flag
export function getFlag(poi) {
  let poiUid = typeof poi === 'string' ? poi : poi.poi_uid;
  poiUid || (poiUid = '');
  let index = poiUid.lastIndexOf('.');
  let key = poiUid.substring(0, index);
  let flag = poiFlagMap[key] || 'poi';

  return flag;
}




/**
 * 停留时间。返回字符串文案
 *
 * @export
 * @param {any} poi
 * @param {any} useAgv 是否使用平均时间计算
 * @returns String
 */
export function getStayTime(poi = {}, useAgv = true) {
  let info = poi.info;

  if (!info || !info.stay_max || !info.stay_agv) return '';

  if(useAgv){
    return minutesToHours(info.stay_agv) + '';
  }

  if (info.stay_max === info.stay_min) {
    return minutesToHours(info.stay_max) + '';
  } else {
    let max = minutesToHours(info.stay_max);
    let min = minutesToHours(info.stay_min);

    return `${min}~${max}`;
  }
}


function minutesToHours(m = 0) {
  let h = Math.round((m / 30).toFixed(1))*0.5 ;
  let i = parseFloat(h);

  if (i < 0.1) {
    i = 0.1;
  }

  return i;
}




/**
 * 通过行程和poiuid数据获取poi详情url
 * 门店
 * 酒店
 * poi
 * @param {*} trip 行程详情
 * @param {*} poiUid  poiuid
 * @param {*} type 类型 【edit || modify || ''】对应去到编辑或者更改的流程的页面
 */

export function getPoiDetailUrl(trip, poiUid, type){
  // 详情页统一使用page=poi（门店除外）
  let url;
  let poi = trip.poi_uid_map[poiUid] || {};

  if (isStore(poi)) {
    url = (poi.info && poi.info.store_link) || '';
  }else if(isUserTravel(poi)){
    let path = type && type !== '' ? `trip-${type}-custompoi` : 'trip-edit-custompoi' ;
    url = `/m/v2/?m=render2&page=${path}`;
  }else if(isUserHotel(poi)){
    let path = type && type !== '' ? `trip-${type}-customhotel` : 'trip-edit-customhotel' ;
    url = `/m/v2/?m=render2&page=${path}`;
  } else if(isHotel(poi)){
    let path = type && type !== '' ? `trip-${type}-hotel` : 'trip-edit-hotel' ;
    url = `/m/v2/?m=render2&page=${path}`;
  }else {
    let path = type && type !== '' ? `trip-${type}-poi` : 'poi';
    url = `/m/v2/?m=render2&page=${path}`;
  }

  return url;
}




export function latLngDecimalToStandard(num, type) {
  num = Number(num) || 0;
  let s = type === 'lat' ?
    (num >= 0 ? 'N' : 'S') :
    (num >= 0 ? 'E' : 'W');
  num = Math.abs(num);
  let r1 = Math.floor(num);
  let r2 = Math.floor((num - r1) * 60);
  let r3 = ((num - r1 - r2/60) * 3600).toFixed(3);


  return `${r1}°${r2}'${r3}"${s}`;
}


const stayTimes = [
  {'text':'不设置'},
  {'text':'1小时'}, 
  {'text':'2小时'}, 
  {'text':'3小时'},
  {'text':'4小时'}, 
  {'text':'5小时'}, 
  {'text':'6小时'},
  {'text':'7小时'},
  {'text':'8小时'}];
export function getStayTimeText(index) {
  return stayTimes[index].text;
}


export function getStayTimesList(){
  return stayTimes;
}


// WEBPACK FOOTER //
// ./src/helpers/poi.js